jQuery_T4NT(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });
});

/* Replace of the elements of the "Eyewear Type" in the filter block */
(function () {
  let checkTypesInterval;

  /* Set timer */
  function checkForTypesElement() {
    checkTypesInterval = setInterval(() => {
      let $genderBlock = document.querySelector(".is--blockideyewear-type");
      if ($genderBlock) {
        moveTypesInFilter();
        // clearInterval(checkTypesInterval);
      }
    }, 500); // 500 = 0.5 ms
  }

  checkForTypesElement();

  /* Replace */
  function moveTypesInFilter() {
    const $ul = document.querySelector(".is--blockideyewear-type ul");
    const $items = $ul.getElementsByTagName("li");

    let $eyeglasses, $sunglasses, $readers;

    for (let i = 0; i < $items.length; i++) {
      if (ifNodeIs($items[i], "eyeglasses")) {
        $eyeglasses = $items[i];
      } else if (ifNodeIs($items[i], "sunglasses")) {
        $sunglasses = $items[i];
      } else if (ifNodeIs($items[i], "readers")) {
        $readers = $items[i];
      }
    }

    if ($eyeglasses && ifNodeIs($items[0], "eyeglasses") === false) {
      $ul.insertBefore($eyeglasses, $items[0]);
    }

    if (
      $items[1] !== undefined &&
      $sunglasses &&
      ifNodeIs($items[1], "sunglasses") === false
    ) {
      $ul.insertBefore($sunglasses, $items[1]);
    }

    if (
      $items[2] !== undefined &&
      $readers &&
      ifNodeIs($items[2], "readers") === false
    ) {
      $ul.insertBefore($readers, $items[2]);
    }
  }

  function ifNodeIs(node, type) {
    return node.getAttribute("data-type") === type;
  }
})();

/* Process Brands in the filter */
(function () {
  const brandParam = "filter.p.m.custom.brand";
  const brandsBlockSelector = ".is--blockidbrand";
  const brandsBlockUlSelector = brandsBlockSelector + " ul";
  const brandCheckboxCheckedClass = "is--selected";
  const rowWithParamsClass = "t4s-active-filters";
  const rowWithParamsSelector = `.${rowWithParamsClass}`;
  const productsFoundSelector = ".t4s-active-filters__count";
  const productsFoundCountSelector = "#filter_results_count";
  const productsSelector = ".t4s-products";
  const paramClass = "t4s-active-filters__remove-filter";
  const rowWithParamsItemsSelector = `${rowWithParamsSelector} a.${paramClass}`;
  const clearAllSelector = ".t4s-active-filters__clear";
  const clearAllHtml = `<a href="${
    window.location.href.split("?")[0]
  }" class="t4s-active-filters__clear">Clear all</a>`;
  let currentUrlParams = [];

  /* Set timer */
  function checkForBrandsElement() {
    let brandsInterval = setInterval(() => {
      let $brandsBlock = document.querySelector(brandsBlockSelector);
      if ($brandsBlock) {
        // clearInterval(brandsInterval);
        processFilterBrands();
      }
    }, 1000); // 1000 = 1s
  }

  checkForBrandsElement();

  function processFilterBrands() {
    const $ul = document.querySelector(brandsBlockUlSelector);
    const $liItems = $ul.getElementsByTagName("li");

    Array.from($liItems).forEach(($li) => {
      let brand = $li.textContent.trim();
      if (brand) {
        const $a = $li.querySelector("a");

        if (isBrandChecked(brand)) {
          $a.href = getLinkWithRemovingBrand(brand);
          $li.classList.add(brandCheckboxCheckedClass);
        } else {
          $a.href = getLinkWithAddingBrand(brand);
        }
      }
    });

    addBrandsToRowWithSearchedParams();
  }

  function isBrandChecked(brand) {
    let searchParams = new URLSearchParams(window.location.search);
    for (let [paramName, paramValue] of searchParams.entries()) {
      if (paramName === brandParam && paramValue === brand) {
        return true;
      }
    }
    return false;
  }

  function getLinkWithRemovingBrand(brand) {
    let [base, paramsString] = window.location.href.split("?");
    let params = paramsString.split("&");

    params = params.filter((param) => {
      let [name, value] = param.split("=");
      let decodedBrand = decodeURIComponent(value.replace(/\+/g, " "));
      return !(name === brandParam && decodedBrand === brand);
    });

    if (params.length === 0) {
      return base;
    }
    return base + "?" + params.join("&");
  }

  function getLinkWithAddingBrand(brand) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.append(brandParam, brand);
    return window.location.pathname + "?" + searchParams.toString();
  }

  function getUrlParamsFromUrl(url) {
    const [base, paramsString] = url.split("?");
    if (paramsString === undefined || paramsString === "") {
      return [];
    }
    let params = paramsString
      .split("&")
      .filter(
        (paramStr) =>
          paramStr.startsWith("filter") &&
          !paramStr.startsWith("filter.v.price")
      );
    return params.map((paramItem) => paramItem.split("="));
  }

  // Go through an array of search criteria items. Take the element url and make an array of parameters
  function getCurrentDeletingParams($linkItems) {
    let deletingParams = [];
    $linkItems.forEach(($linkItem) => {
      let linkItemParams = getUrlParamsFromUrl($linkItem.href);
      // Compare the array of the current url with the array of the element's url. Which criterion is
      // missing in the current element, it means it is minus this criterion
      let deletingParam = currentUrlParams.filter((urlParamsItem) => {
        let issetParams = false;
        linkItemParams.forEach((linkParamsItem) => {
          if (
            linkParamsItem[0] === urlParamsItem[0] &&
            linkParamsItem[1] === urlParamsItem[1]
          ) {
            issetParams = true;
            return false;
          }
        });
        return !issetParams;
      });
      deletingParams.push(deletingParam[0]);
    });
    return deletingParams;
  }

  function getParamsForAddingWithCompareParams(currentDeletingParams) {
    return currentUrlParams.filter((paramItem) => {
      let issetParamInLinkItems = false;
      currentDeletingParams.forEach((deletingParam) => {
        // console.log(`deletingParam type: ${deletingParam}`);
        if (
          deletingParam.length > 0 &&
          deletingParam[0] === paramItem[0] &&
          deletingParam[1] === paramItem[1]
        ) {
          issetParamInLinkItems = true;
          return false;
        }
      });
      return !issetParamInLinkItems;
    });
  }

  function checkClearAllButton() {
    let $rowWithSearchedParams = document.querySelector(rowWithParamsSelector);

    // Add "Clear All" button
    if (
      $rowWithSearchedParams !== null &&
      document.querySelector(clearAllSelector) === null
    ) {
      $rowWithSearchedParams.insertAdjacentHTML("beforeend", clearAllHtml);
    }
  }

  function addParamsToRow(paramsForAdding) {
    let $rowWithSearchedParams = document.querySelector(rowWithParamsSelector);
    let $productsFound = document.querySelector(productsFoundSelector);

    // If absent row with search params
    if ($rowWithSearchedParams === null) {
      $rowWithSearchedParams = document.createElement("div"); // Создаем новый элемент
      $rowWithSearchedParams.classList.add(rowWithParamsClass);
      const $searchedProducts = document.querySelector(productsSelector);
      $searchedProducts.parentNode.insertBefore(
        $rowWithSearchedParams,
        $searchedProducts
      );
    }

    // If absent HTML-tag with information about the found products
    if ($productsFound === null) {
      let $productsFoundCount = document.querySelector(
        productsFoundCountSelector
      );
      let productsFound =
        $productsFoundCount !== null ? $productsFoundCount.textContent : "";
      const $foundProductsHtml = `<div class="t4s-active-filters__count t4s-d-inline-block" data-custom="true"><span class="cp">${productsFound}</span> Products Found</div>`;
      $rowWithSearchedParams.insertAdjacentHTML(
        "afterbegin",
        $foundProductsHtml
      );
    }

    checkClearAllButton();
    const $clearAll = document.querySelector(clearAllSelector);

    paramsForAdding.forEach((param) => {
      let paramName = decodeURIComponent(param[1].replace(/\+/g, " "));
      const $newLinkHtml = `<a class="${paramClass}" href="${getNewLinkItem(
        param
      )}">${paramName}</a>`;
      $clearAll.insertAdjacentHTML("beforebegin", $newLinkHtml);
    });
  }

  function getNewLinkItem(removeParam) {
    const newUrlParams = currentUrlParams.filter((paramItem) => {
      return removeParam !== paramItem;
    });
    const paramUrl = newUrlParams
      .map((paramItem) => paramItem.join("="))
      .join("&");
    const scriptUrl = window.location.href.split("?")[0];

    return scriptUrl + "?" + paramUrl;
  }

  function addBrandsToRowWithSearchedParams() {
    const $linkItems = document.querySelectorAll(rowWithParamsItemsSelector);
    currentUrlParams = getUrlParamsFromUrl(window.location.href);
    if ($linkItems.length !== currentUrlParams.length) {
      let currentDeletingParams = getCurrentDeletingParams($linkItems);
      // console.log(`currentDeletingParams type: ${typeof(currentDeletingParams)}`);
      let paramsForAdding = getParamsForAddingWithCompareParams(
        currentDeletingParams
      );

      // Add the remaining parameters of the current url as elements in the criteria string
      if (paramsForAdding.length > 0) {
        addParamsToRow(paramsForAdding);
      }
    } else {
      checkClearAllButton();
    }
  }
})();

/* Process toggle blocks in the filter */
(function () {
  // Criterion in lower case format
  const eyeglassesSections = ["sunglass clip-ons", "lens height"];
  const sunglassesSections = ["lens type", "lens color"];
  const readersSections = ["lens height", "strength"];
  const typeParam = "filter.p.product_type";
  let productTypes = [];

  /* Set timer */
  function toggleBlocks() {
    let filterBlocksInterval = setInterval(() => {
      if (document.querySelectorAll(".t4s-facet").length > 0) {
        // clearInterval(filterBlocksInterval);
        processToggleBlocks();
      }
    }, 1000); // 1000 = 1s
  }

  toggleBlocks();

  /**
   * Go through the filter blocks. Check the current status of the criterion in the filter and change the status
   * to a new one
   */
  function processToggleBlocks() {
    productTypes = getProductTypes();
    $(".t4s-facet").each(function () {
      let label = $(this).find("h5").text();
      let isVisible = $(this).is(":visible");
      let needHide = ifNeedHideBlock(label);
      if (isVisible && needHide) {
        $(this).hide();
      } else if (!isVisible && !needHide) {
        $(this).show();
      }
    });
  }

  /**
   * Get the list of selected types of glasses from the URL
   * @return {[]} product types in lower cases
   */
  function getProductTypes() {
    const urlParams = getUrlParamsFromUrl();
    let types = [];
    for (let i in urlParams) {
      let [param, value] = urlParams[i];
      if (param === typeParam) {
        types.push(value.toLowerCase());
      }
    }
    return types;
  }

  /**
   * Return parameters of the URL in array
   * @return {*[]|*}
   */
  function getUrlParamsFromUrl() {
    const [base, paramsString] = window.location.href.split("?");
    if (paramsString === undefined || paramsString === "") {
      return [];
    }
    const params = paramsString.split("&");
    return params.map((paramItem) => paramItem.split("="));
  }

  /**
   * Pass the name of the criterion (Filter label) and return the decision whether to hide the block or not
   * @param label Label of the criterion
   * @return {boolean}
   */
  function ifNeedHideBlock(label) {
    label = label.toLowerCase();
    let isLabelInType = false;

    // Define `labelIssetInSettings`
    let isLabelInSettings = false;
    for (let section of eyeglassesSections) {
      if (label === section) {
        isLabelInSettings = true;
      }
    }
    for (let section of sunglassesSections) {
      if (label === section) {
        isLabelInSettings = true;
      }
    }
    for (let section of readersSections) {
      if (label === section) {
        isLabelInSettings = true;
      }
    }
    if (!isLabelInSettings) {
      return false;
    }

    if (
      !productTypes.includes("eyeglasses") &&
      !productTypes.includes("sunglasses") &&
      !productTypes.includes("readers")
    ) {
      return true;
    }

    if (
      productTypes.includes("eyeglasses") &&
      !eyeglassesSections.includes(label)
    ) {
      return true;
    }
    if (
      productTypes.includes("sunglasses") &&
      !sunglassesSections.includes(label)
    ) {
      return true;
    }
    if (productTypes.includes("readers") && !readersSections.includes(label)) {
      return true;
    }

    return false;
  }
})();

/** Update product title, additional information, attributes - add/change for: color, color code, size, strength,
 * lens height, UPC **/
(function () {
  const basicTitle = getBasicTitle();

  $(document).ready(function () {
    addClickEvents();
  });

  // Return jQuery object of title
  function getTitleObj() {
    return $("h1.t4s-product__title");
  }

  // Return basic title
  function getBasicTitle() {
    let title = $.trim(getTitleObj().text());
    const keywords = [
      " Eyeglasses",
      " Sunglasses",
      " Readers",
      " eyeglasses",
      " sunglasses",
      " readers",
    ];

    for (let keyword of keywords) {
      const keywordPosition = title.indexOf(keyword);

      // If the keyword is found, return the substring up to the end of the keyword
      if (keywordPosition !== -1) {
        return title.substring(0, keywordPosition + keyword.length);
      }
    }

    return "";
  }

  // Add click event on colors, sizes, strengths
  function addClickEvents() {
    const colorSelector = ".is-sw__color";
    const sizeSelector = ".is-t4s-name__size .t4s-swatch__item";
    const strengthSelector = ".is-t4s-name__size .t4s-swatch__item";
    const dropdownSelector = ".t4s-dropdown__content.t4s-current-scrollbar";
    $(document).on(
      "click",
      `${colorSelector}, ${sizeSelector}, ${strengthSelector}, ${dropdownSelector}`,
      [],
      function () {
        updateTitleWithSelectedValues();
        updateAdditionalInformationValues();
        // updateAttributesValues();
      }
    );
  }

  // Update title with the selected values
  function updateTitleWithSelectedValues() {
    setTimeout(() => {
      let color = getSelectedColor();
      let size = getSelectedSize();
      let strength = getSelectedStrength();
      updateTitle(color, size, strength);
    }, 100);
  }

  // Update options in Additiona Information block
  function updateAdditionalInformationValues() {
    setTimeout(() => {
      let color = getSelectedColor();
      let colorCode = getSelectedColorCode();
      let size = getSelectedSize();
      let strength = getSelectedStrength();
      let lensHeight = getLensHeight();
      let upc = getUpc();
      updateAdditionalInformation(
        color,
        colorCode,
        size,
        strength,
        lensHeight,
        upc
      );
    }, 100);
  }

  // Update options in Attributes block
  function updateAttributesValues() {
    setTimeout(() => {
      let color = getSelectedColor();
      let size = getSelectedSize();
      let strength = getSelectedStrength();
      let lensHeight = getLensHeight();
      updateAttributes(color, size, strength, lensHeight);
    }, 100);
  }

  // Update title: add color, size, strength in the end
  function updateTitle(color, size, strength) {
    let title = `${basicTitle} - ${color}, ${size}`;
    if (strength !== "") {
      title = `${basicTitle} - ${color}, ${size}, ${strength}`;
    }
    getTitleObj().text(title);
  }

  function getSelectedSizeObj() {
    return $(".is-t4s-name__size .t4s-swatch__item.is--selected");
  }

  // Return the selected size text
  function getSelectedSize() {
    return $.trim(getSelectedSizeObj().text());
  }

  // Return the selected strength text
  function getSelectedStrength() {
    return $.trim(
      $(".is-t4s-name__strength .t4s-swatch__item.is--selected").text()
    );
  }

  // Return Lens Height of the variant
  function getLensHeight() {
    return getSelectedSizeObj().data("lens_height");
  }

  // Return the selected color text
  function getSelectedColor() {
    return $.trim($(".is-sw__color.is--selected").text());
  }

  // Return the selected color text
  function getUpc() {
    return $.trim($(".t4s-product_meta .t4s-barcode-value").text());
  }

  // Return the selected color code text
  function getSelectedColorCode() {
    return $.trim($(".is-sw__color.is--selected").data("color_code"));
  }

  // Update Additional Information: color, color code, size, strength, lens height, upc
  function updateAdditionalInformation(
    color,
    colorCode,
    size,
    strength,
    lensHeight,
    upc
  ) {
    const $colorElement = $(
      ".moda-attributes .moda-item_color .moda-attributes__value"
    );
    const $colorCodeElement = $(
      ".moda-attributes .moda-item_color-code .moda-attributes__value"
    );
    const $lensWidthElements = $(
      ".moda-guide__lens-width .moda-guide__lens-width-value, .moda-guide__instructions-value.moda-guide__instructions-lens-width"
    );
    const $bridgeWidthElements = $(
      ".moda-guide__bridge-width .moda-guide__bridge-width-value, .moda-guide__instructions-value.moda-guide__instructions-bridge-width"
    );
    const $templeLengthElements = $(
      ".moda-guide__temple-length .moda-guide__temple-length-value, .moda-guide__instructions-value.moda-guide__instructions-temple-length"
    );
    const $strengthElement = $(
      ".t4s-pr_attrs .t4s-attr_pa_strength .t4s-attr__value p"
    );
    const $lensHeightElement = $(
      ".moda-guide__lens-height .moda-guide__lens-height-value"
    );
    const $upcElement = $(
      ".moda-attributes .moda-item_barcode .moda-attributes__value"
    );

    const lensWidth = getLensWidthFromSize(size);
    const bridgeWidth = getBridgeWidthFromSize(size);
    const templeLength = getTempleLengthFromSize(size);

    $colorElement.text(color);
    $colorCodeElement.text(colorCode);
    $lensWidthElements.text(lensWidth);
    $bridgeWidthElements.text(bridgeWidth);
    $templeLengthElements.text(templeLength);
    $upcElement.text(upc);

    if (strength !== "") {
      $strengthElement.text(strength);
    }
    if (lensHeight !== "") {
      $lensHeightElement.text(`${lensHeight}`);
    }
  }

  function getLensWidthFromSize(size) {
    return size.split("-")[0];
  }

  function getBridgeWidthFromSize(size) {
    return size.split("-")[1];
  }

  function getTempleLengthFromSize(size) {
    return size.split("-")[2];
  }

  // Update Attributes: color, size, strength
  function updateAttributes(color, size, strength, lensHeight) {
    const $colorElement = $(".t4s-product_meta .t4s-option_color span");
    const $sizeElement = $(".t4s-product_meta .t4s-option_size span");
    const $strengthElement = $(".t4s-product_meta .t4s-option_strength span");
    const $lensHeightElement = $(
      ".t4s-product_meta .t4s-option_lens_height span"
    );

    $colorElement.text(color);
    $sizeElement.text(size);
    if (strength !== "") {
      $strengthElement.text(strength);
    }
    if (lensHeight !== "") {
      $lensHeightElement.text(lensHeight);
    }
  }
})();

/* Click on Size Guide on the page with cart of the product */
$(".moda-size-guide__link").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".t4s-tabs-ul").offset().top,
    },
    800,
    function () {
      $("#b_e36839f5-0847-44e2-97d3-2885597bd1ff").click();
    }
  );
});

/* Update brands list in Filter according to the selected type of glasses */
(function () {
  let checkBrandsInterval;
  const brandSelector = ".is--blockidbrand";
  const productTypeSelector = ".is--blockideyewear-type";
  const typesList = {
    Eyeglasses: 1,
    Sunglasses: 2,
    Readers: 3,
  };
  const brandsJsonUrl =
    "https://vistalister.eleganzo.com/data/modaframes/brands/filter_brands.json";

  let allBrands = [];

  function checkBrandBlock() {
    checkBrandsInterval = setInterval(() => {
      const $brandBlock = $(brandSelector);
      if ($brandBlock) {
        // clearInterval(checkBrandsInterval);
        loadBrands();
      }
    }, 900); // 500 = 0.5 ms
  }

  checkBrandBlock();

  function loadBrands() {
    const $brandsUl = $(brandSelector).find("ul");
    if (!$brandsUl.data("modified")) {
      fetch(brandsJsonUrl)
        .then((response) => response.json())
        .then((data) => {
          allBrands = data;
          updateBrandsOnPage();
        })
        .catch((error) => console.error("Error loading brands:", error));
    }
  }

  function updateBrandsOnPage() {
    const $brandBlock = $(brandSelector);
    const typesIds = getSelectedProductTypesIds();
    let brands = getBrandsList(typesIds);
    let brandsListHtml = getBrandsListHtml(brands);
    const $brandsUl = $brandBlock.find("ul");
    if (!$brandsUl.data("modified")) {
      $brandsUl.data("modified", "true");
      $brandBlock.find("ul").html(brandsListHtml);
    }
  }

  function getBrandsListHtml(brands) {
    let html = "";
    Array.from(brands).forEach((brand) => {
      html += "<li>";
      html += `<a href="/">`;
      html += '<div class="t4s-checkbox-wrapper t4s-pr t4s-oh">';
      html += '<svg focusable="false" viewBox="0 0 24 24" role="presentation">';
      html +=
        '<path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path>';
      html += "</svg>";
      html += "</div>";
      html += brand;
      html += "</a>";
      html += "</li>";
    });
    return html;
  }

  function getBrandsList(typesIds) {
    let brands = [];
    for (let i in typesIds) {
      brands = brands.concat(allBrands[typesIds[i]]);
    }
    // return [...new Set(brands)].sort();
    return [...new Set(brands)].sort((a, b) =>
      a.localeCompare(b, "en", { sensitivity: "base" })
    );
  }

  function getSelectedProductTypesIds() {
    const $productTypeBlock = $(productTypeSelector);
    let types = [];
    $productTypeBlock.find("li.is--selected").each(function (i) {
      let type = $.trim($(this).text());
      type = type.split("(")[0];
      types.push(typesList[type]);
    });
    if (types.length === 0) {
      types = Object.values(typesList);
    }
    return types;
  }
})();

/* Bread Crumbs from session store of the browser */
(function () {
  $(document).ready(function () {
    // Event for saving collection on the link click
    $(document).on(
      "click",
      ".t4s-product .t4s-product-title a, .t4s-product .t4s-product-inner a",
      [],
      function () {
        let collectionUrl = window.location.href;
        let collectionTitle = $.trim($("h1").text());
        isCollectionPage = currentUrl.match(/\/collections\//);
        if (isCollectionPage) {
          saveCollection(collectionUrl, collectionTitle);
        } else {
          saveCollection("", "");
        }
      }
    );

    // Change bread crumbs on the product page
    const currentUrl = window.location.href;
    const isProductPage = currentUrl.match(/\/products\//);
    if (isProductPage) {
      // Если мы на странице продукта, извлекаем информацию о коллекции из sessionStorage
      const collectionUrl = sessionStorage.getItem("collectionUrl");
      const collectionTitle = sessionStorage.getItem("collectionTitle");

      if (collectionUrl && collectionTitle) {
        const $breadCrumbs = $("nav.t4s-pr-breadcrumb");
        const separator = $breadCrumbs.find("svg").first().clone();
        const linkClass = $breadCrumbs.find("a").first().attr("class");
        const brand = $.trim($breadCrumbs.find("a").last().text());

        if (brand !== collectionTitle) {
          // Создаем ссылку на коллекцию
          const collectionLink = $("<a></a>")
            .attr("href", collectionUrl)
            .attr("class", linkClass)
            .text(collectionTitle);

          // Вставляем ссылку на коллекцию и разделитель между первой и второй ссылкой
          $("nav.t4s-pr-breadcrumb a")
            .first()
            .after(collectionLink)
            .after(separator);
        }
      }
    }
  });

  function saveCollection(collectionUrl, collectionTitle) {
    sessionStorage.setItem("collectionUrl", collectionUrl);
    sessionStorage.setItem("collectionTitle", collectionTitle);
  }
})();

/* Raise the search form above */
(function () {
  let checkBrandsInterval;
  const genderSelector = ".is--blockidgender";
  const shapeSelector = ".is--blockidshape";

  function checFilterBlocks() {
    checkBrandsInterval = setInterval(() => {
      const $gender = $(genderSelector);
      const $shape = $(shapeSelector);
      if ($gender.length && $shape.length && !$gender.data("shape-elevated")) {
        elevateShape();
      }
    }, 900); // 500 = 0.5 ms
  }

  checFilterBlocks();

  function elevateShape() {
    const $gender = $(genderSelector);
    const $shape = $(shapeSelector);
    $shape.insertAfter($gender);
    $gender.data("shape-elevated", true);
    $(shapeSelector).not(":first").remove(); // Removes duplicates. Otherwise, the Shape block appears 3 times
  }
})();